export default "__VITE_PUBLIC_ASSET__82cfc342__"